import { render, staticRenderFns } from "./PerkinGabungan.vue?vue&type=template&id=53b4edc7&scoped=true&"
import script from "./PerkinGabungan.vue?vue&type=script&lang=js&"
export * from "./PerkinGabungan.vue?vue&type=script&lang=js&"
import style0 from "./PerkinGabungan.vue?vue&type=style&index=0&id=53b4edc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b4edc7",
  null
  
)

export default component.exports